import { getApiClient } from "@punchup/utils";
import type {
  ComedianAudienceCountRequest,
  ComedianAudienceCountResponse,
} from "../../models/messaging/audience-count.types";

export async function fetchComedianAudienceCount(
  request: ComedianAudienceCountRequest
): Promise<ComedianAudienceCountResponse> {
  return getApiClient()
    .post<{ data: ComedianAudienceCountResponse }>(
      "/api/v2/manager/messaging/audience-count/comedian",
      request
    )
    .then((res) => res.data);
}
